<span class="task-view-comment-form-time__icon">
  <i class="icon-time"></i>
  <i class="icon-close" (click)="clear.emit()"></i>
</span>
<span class="task-view-comment-form-time__label">Затрачено:</span>
<span class="task-view-comment-form-time__value">{{ hours() }} часа {{ minutes() }} минут</span>
